export const authorFromTypeToTitle = {
  "pl": {
    author: 'Tekst',
    editedBy: 'Redakcja',
    reviewedBy: 'Recenzja',
    factChecker: 'Fact-checking',
    updatedBy: 'Redakcja'
  },
  "en-GB": {
    author: 'Author',
    editedBy: 'Edited by',
    reviewedBy: 'Reviewed by',
    factChecker: 'Fact-checking',
    updatedBy: 'Updated by'
  },
  "uk": {
    author: 'Автор',
    editedBy: 'Автор',
    reviewedBy: 'За редакцією',
    factChecker: 'Перевірено',
    updatedBy: 'Перевірка фактів'
  },
  "de": {
    author: 'Autor',
    editedBy: 'Bearbeitet von',
    reviewedBy: 'Rezensiert von',
    factChecker: 'Faktenüberprüfung',
    updatedBy: 'Aktualisiert von'
  },

  "cs": {
    author: 'Autor',
    editedBy: 'Redakce',
    reviewedBy: 'Recenze',
    factChecker: 'Kontrola faktů',
    updatedBy: 'Aktualizováno'
  },
  "ro": {
    author: 'Autor',
    editedBy: 'Editorial',
    reviewedBy: 'Recenzie',
    factChecker: 'Verificarea faptelor',
    updatedBy: 'Editorial'
  },
  "hu": {
    author: 'Szerző',
    editedBy: 'Szerkesztőség',
    reviewedBy: 'Felülvizsgálat',
    factChecker: 'Tényellenőrzés',
    updatedBy: 'Szerkesztőség'
  },
  "sk": {
    author: 'Autor',
    editedBy: 'Redakcia',
    reviewedBy: 'Prehľad',
    factChecker: 'Overovanie faktov',
    updatedBy: 'Redakcia'
  },
  "bg": {
    author: 'Autor',
    editedBy: 'Редакция',
    reviewedBy: 'Преглед на',
    factChecker: 'Проверка на фактите',
    updatedBy: 'Редакция'
  },
  "fr": {
    "author": "Auteur",
    "editedBy": "Modifié par",
    "reviewedBy": "Examiné par",
    "factChecker": "Vérification des faits",
    "updatedBy": "Mis à jour par"
  },  
  "it": {
    "author": "Autore",
    "editedBy": "Modificato da",
    "reviewedBy": "Revisionato da",
    "factChecker": "Verifica dei fatti",
    "updatedBy": "Aggiornato da"
  },
  "es": {
    "author": "Autor",
    "editedBy": "Editado por",
    "reviewedBy": "Revisado por",
    "factChecker": "Verificación de hechos",
    "updatedBy": "Actualizado por"
  },
  "nl": {
    "author": "Auteur",
    "editedBy": "Bewerkt door",
    "reviewedBy": "Beoordeeld door",
    "factChecker": "Feitencontrole",
    "updatedBy": "Bijgewerkt door"
  },
  "sv": {
    "author": "Författare",
    "editedBy": "Redigerad av",
    "reviewedBy": "Granskad av",
    "factChecker": "Faktagranskning",
    "updatedBy": "Uppdaterad av"
  },
  "pt": {
    "author": "Autor",
    "editedBy": "Editado por",
    "reviewedBy": "Revisado por",
    "factChecker": "Verificação de fatos",
    "updatedBy": "Atualizado por"
  },
  "da": {
    "author": "Forfatter",
    "editedBy": "Redigeret af",
    "reviewedBy": "Gennemgået af",
    "factChecker": "Faktatjek",
    "updatedBy": "Opdateret af"
  },
  "fi": {
    "author": "Tekijä",
    "editedBy": "Muokannut",
    "reviewedBy": "Tarkistanut",
    "factChecker": "Faktantarkistus",
    "updatedBy": "Päivittänyt"
  }
}
